import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import EditSchema from './EditSchema';
import View from './View';

const QuoteEdit = (props) => {
  const { selected } = props;

  return (
    <>
      <div className="fcmh-quote--edit">
        <View {...props} isEditMode />
      </div>

      {/* Sidebar-Form */}
      <SidebarPortal selected={selected}>
        <EditSchema {...props} />
      </SidebarPortal>
    </>
  );
};

export default QuoteEdit;
